import { DatabaseService } from './database.service';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { APIService } from './api.service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class PendingOrderService {

    constructor(
        public alertController: AlertController,
        private router: Router,
        private authService: AuthService,
        private apiService: APIService,
        private databaseService: DatabaseService
    ) { }

    addPendingOrder(order_data,idempotency_key) {
        return new Promise((resolve, reject) => {
            let pending_order = {};
            pending_order["order_data"] = order_data;
            pending_order["idempotency_key"] = idempotency_key;
            this.databaseService.pending_order.add(pending_order)
                .then((id) => {
                    resolve(id);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    deletePendingOrder(pending_order) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.pending_order
                .delete(pending_order.id)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getPendingOrders() {
        return new Promise((resolve, reject) => {
            this.databaseService.pending_order
                .toArray()
                .then((pending_orders) => {
                    resolve(pending_orders);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    processPendingOrders() {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.pending_order.toArray().then((pending_orders) => {
                for (let i = 0; i < pending_orders.length; i++) {
                    // NOTE: sends each order 5 seconds apart to avoid overloading the Xero API
                    setTimeout(() => {
                        this.authService.isLoggedIn().then(() => {
                            this.apiService.addOrder(pending_orders[i].order_data, pending_orders[i].idempotency_key).then((order) => {
                                // TODO: update payment intents for stripe terminal so has correct description, metadata, shipping
                                this.deletePendingOrder(pending_orders[i]).then(() => {
                                    if(pending_orders[i].email_invoice_to_email_address) {
                                        this.apiService.sendOrderInvoiceEmail(order['id'], pending_orders[i].email_invoice_to_email_address).catch((error) => {
                                            // do nothing
                                        });
                                    }
                                    if(pending_orders[i].email_confirmation_to_email_address) {
                                        this.apiService.sendOrderConfirmationEmail(order['id'], pending_orders[i].email_confirmation_to_email_address).catch((error) => {
                                            // do nothing
                                        });
                                    }
                                })
                                .catch(() => {
                                    reject();
                                });
                            })
                            .catch((error) => {
                                if(error.status) {
                                    // don't throw error if there's a conflict (i.e. idempotency key being replayed)
                                    if(error.status != 409) {
                                        if(error.status === 400) {
                                            this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to add a pending order.");
                                        } else if(error.status === 403) {
                                            this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to add an order.");
                                        } else if(error.status === 404 || error.status === 500 || error.status === 501 || error.status === 502 || error.status === 503 || error.status === 504 || error.status === 0) {
                                            this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to add a pending order at time.");
                                        }
                                        reject();
                                    }
                                    // delete order if there's a conflict
                                    else {
                                        this.deletePendingOrder(pending_orders[i]);
                                    }
                                }
                            });
                        })
                        .catch(() => {
                            this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                                window.location.reload();
                            });
                            reject();
                        });
                    }, i * 5000);
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    updatePendingOrder(id, data) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.pending_order.update(id, data).then(() => {
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }
    
    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ['OK'],
        });
        await alert.present();
    }

}
